module.exports = __webpack_public_path__ + "media/images/logos/mrzen-logo-47bd524687b2fbcc2bced3f23d6e3655.svg";